import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonComponent } from '@components';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-page',
  standalone: true,
  imports: [BreadcrumbComponent, SkeletonComponent],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageComponent {
  readonly title = input.required<string>();
  readonly showTitleSkeleton = input<boolean>(false);
}
